import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';
import {
  Typography,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Avatar,
  colors, Select,
  Dialog, DialogTitle, DialogContent, DialogActions, Button
} from '@material-ui/core';
import Label from 'src/components/Label';
import AvatarEngineer from 'src/assets/images/technician.png';
import PersonAddIcon from '@material-ui/icons/PersonAdd';
import CloseIcon from '@material-ui/icons/Close';
import { getUser } from 'src/utils/Common';
import axios from 'src/utils/axios';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import { useHistory } from 'react-router';
import Alert from 'src/components/Alert';
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff';
import { Snackbar } from '@material-ui/core';


const useStyles = makeStyles((theme) => ({
  active: {
    boxShadow: `inset 4px 0px 0px ${theme.palette.primary.main}`,
    backgroundColor: colors.grey[50]
  },
  avatar: {
    height: 40,
    width: 40
  },
  details: {
    marginLeft: theme.spacing(2),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end'
  },
  unread: {
    marginTop: 2,
    padding: 2,
    height: 18,
    minWidth: 18
  },
  submitButtonDirect: {
    marginTop: theme.spacing(0),
    width: '100%'
  }
}));

function ConversationListItem({
  getData,
  active, conversation, className, ...rest
}) {
  const [responseMessage, setresponseMessage] = React.useState({ ErrorCode: '0', ErrorDescription: 'İşleminiz başarı ile gerçekleştirildi.' });
  const [uyari, setUyari] = React.useState(false);
  const [uyariTip, setUyariTip] = React.useState();
  const classes = useStyles();
  const [UserPopup, setUserPopup] = React.useState(false);
  const [UsersData, setUsersData] = React.useState([]);
  const [paramBasvuruNo, setparamBasvuruNo] = React.useState(0);

  const [value, setValue] = React.useState(0);
  const [hiddenMessage, setHiddenMessage] = React.useState({
    open: false,
    message: "",
    type: ""
  });
  const history = useHistory();
  const SessionUser = getUser();
  const Yonlendir = (BasvuruNo) => {
    // axios.get(`GetArtemisCommentUsers/${SessionUser.ServiceShopId}/${SessionUser.UserId}`)
    //   .then((response) => {
    //     const Deger = response.data;
    //     setUsersData(Deger);
    //     setparamBasvuruNo(BasvuruNo);
    //     setUserPopup(true);
    //   }).catch((error) => {

    //   });
  };

  const uyariKapat = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setUyari(false);
  };
  const handleChange = (e) => {
    setValue(e.target.value);
  };

  const SetCommentDirect = () => {
    confirmAlert({
      message: 'Yorumunuz yönlendirilecektir. Onaylıyor musunuz?',
      buttons: [
        {
          label: 'Evet',
          onClick: () => YorumYonlendirEvet()
        },
        {
          label: 'Hayır',
          onClick: () => { }
        }
      ]
    });
  };

  const YorumYonlendirEvet = () => {
    const data = [{
      AppNr: paramBasvuruNo,
      ServiceShopId: 0,
      CommentRequested: 0,
      UserId: value,
      Comment: '',
      Operation: 3,
      CommentId: 0,
      Decision: 0,
    }];
    const config = {
      headers: { 'Content-Type': 'application/json' }
    };
    axios.post('/SetArtemisComment', data, config).then((response) => {
      const ResponseData = response.data;
      setresponseMessage(ResponseData);
      if (ResponseData.ErrorCode === '0') {
        history.push('/chat');
      } else {
        setUyariTip('error');
        setUyari(true);
      }
    }).catch((error) => {
      setresponseMessage({ ErrorCode: 10, ErrorDescription: 'Bir hata oluştu!..' });
      setUyariTip('error');
      setUyari(true);
    });
  };
  const hideChat = () => {
    if (conversation.is_active) {
      setHiddenMessage({
        open: true,
        message: "Something Went Wrong",
        type: "error"
      })
    } else {
      axios.get(`/HideChat/${conversation?.ChatId}`)
        .then(response => {
          getData();
          setHiddenMessage({
            open: true,
            message: "Chat Hide Successfully",
            type: "success"
          })
        }).catch(error => {});
    }
  }
  return (
    <div>
      {
        uyari && <Alert onClose={uyariKapat} message={responseMessage.ErrorDescription} variant={uyariTip} />
      }
      {hiddenMessage?.open &&
        <Snackbar
          open={hiddenMessage?.open}
          onClose={() => setHiddenMessage({ open: false, message: "", type: "" })}
        >
          <Alert
            onClose={() => setHiddenMessage({ open: false, message: "", type: "" })}
            message={hiddenMessage?.message}
            variant={hiddenMessage?.type} />
        </Snackbar>
      }
      <ListItem
        {...rest}
        button
        className={clsx({ [classes.active]: active }, className)}
        component={RouterLink}
        to={`/chat/${conversation.ChatId}`}
      >
        <ListItemAvatar>
          <Avatar
            alt="Person"
            className={classes.avatar}
            src={AvatarEngineer}
          />
        </ListItemAvatar>
        <ListItemText
          primary={conversation.otherUserName}
          primaryTypographyProps={{
            noWrap: true,
            variant: 'h6'
          }}
          secondary={`${conversation.LastMessage}`}
          secondaryTypographyProps={{
            noWrap: true,
            variant: 'body1',
            style: SessionUser?.TechnicianId !== conversation?.Sender && !conversation?.IsRead
              ? { fontWeight: "bold" } : {}
          }}
        />
        <div className={classes.details}>
          <Typography
            noWrap
            variant="body2"
            style={SessionUser?.TechnicianId !== conversation?.Sender && !conversation?.IsRead
               ? { fontWeight: "bold" } : {}}
          >
            {conversation.LastMessageDate}
          </Typography>
          {conversation.unread > 0 && (
            <Label
              className={classes.unread}
              color={colors.green[500]}
              shape="rounded"
            >
              {conversation.unread}
            </Label>
          )}
          <Typography
            variant="h7"
            onClick={() => hideChat()}
          >
            <VisibilityOffIcon size={5} />
          </Typography>
        </div>
      </ListItem>
      <Dialog
        open={UserPopup}
        onClose={() => setUserPopup(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth
      >
        <DialogTitle id="alert-dialog-title">
          Yönlendirilecek Kullanıcı Seçiniz!..
        </DialogTitle>
        <DialogContent>
          <Select
            native
            value={value}
            onChange={handleChange}
            label="Yonlendir"
            fullWidth
            labelId="user_label"
            inputProps={{
              name: 'user_select',
              id: 'user_select'
            }}
          >
            <option value="0" defaultValue>Kullanıcı Seçiniz!...</option>
            {UsersData.map((p) => <option key={p.ID} value={p.ID}>{p.ADSOYAD}</option>)}
          </Select>
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            color="primary"
            onClick={() => SetCommentDirect()}
            className={classes.submitButtonDirect}
            endIcon={<PersonAddIcon>Yonlendir</PersonAddIcon>}
          >
            Yönlendir
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={() => setUserPopup(false)}
            className={classes.buttonMaterial}
            endIcon={<CloseIcon>Close</CloseIcon>}
          >
            Kapat
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

ConversationListItem.propTypes = {
  active: PropTypes.bool,
  className: PropTypes.string,
  conversation: PropTypes.object.isRequired
};

export default ConversationListItem;
